import Code from "@tiptap/extension-code"

const CustomCode = Code.extend({
  inclusive: false,
})

export default CustomCode
